import { FormsModule, NgForm } from '@angular/forms';
import { Component, EventEmitter, Input, Output, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { EmrButtonComponent, EmrTextboxComponent, EmrValidationMessage } from 'emr-ng-shared';

@Component({
    selector: 'app-forgot-password-form',
    templateUrl: './forgot-password-form.component.html',
    standalone: true,
    imports: [EmrButtonComponent, EmrTextboxComponent, FormsModule, EmrValidationMessage,]
})
export class ForgotPasswordFormComponent implements OnInit {
    @Input() error: string;
    @Output() submitted = new EventEmitter<string>();
    @ViewChild(NgForm) forgotPasswordForm: NgForm;
    username = '';

    constructor() { }

    ngOnInit() {
    }

    onForgotPasswordClick(event) {
        if (!this.forgotPasswordForm.invalid) {
            this.error = '';
            this.submitted.emit(this.username);
        }
    }
}

